export default "__VITE_ASSET__s4c0vDP6__"